import { PropsWithChildren } from "react";

import { ForgeIconLight } from "./ForgeIconLight";
import { ForgeIconRegular } from "./ForgeIconRegular";
import { ForgeIconSolid } from "./ForgeIconSolid";
import { ForgeIconThin } from "./ForgeIconThin";

type ForgeIconProps = PropsWithChildren<{
  weight?: "solid" | "regular" | "light" | "thin";
  className?: string;
}>;

export const ForgeIcon = (props: ForgeIconProps) => {
  const { weight = "solid", ...rest } = props;
  switch (weight) {
    case "solid":
      return <ForgeIconSolid {...rest} />;
    case "regular":
      return <ForgeIconRegular {...rest} />;
    case "light":
      return <ForgeIconLight {...rest} />;
    case "thin":
      return <ForgeIconThin {...rest} />;
  }
  return null;
};
